import React from "react";
import PropTypes from "prop-types";
import {
    OptionCheckBoxGroup,
    OptionCheckBox
} from "./../Components/OptionsCheckBox";
import Select from "react-select";
import axios from "axios";
import Button from "../Components/Button";
import { Range, Handle, createSliderWithTooltip } from "rc-slider";
import ToolTip from "rc-tooltip";

const NewRange = createSliderWithTooltip(Range);

const handle = props => {
    const { value, dragging, index, ...restProps } = props;

    handle.propTypes = {
        value: PropTypes.any,
        dragging: PropTypes.any,
        index: PropTypes.any
    };

    return (
        <ToolTip
            prefixCls="rc-slider-tooltip"
            overlay={value}
            visible={dragging}
            placement="top"
            key={index}>
            <Handle value={value} {...restProps} />{" "}
        </ToolTip>
    );
};

export default class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: props.options,
            selectedManufacturers: []
        };

        this.handleSelect = this.handleSelect.bind(this);
        this.fetchManufacturers = this.fetchManufacturers.bind(this);
    }
    render() {
        return (
            <div className="sidebar-filter">
                <h2 className="title h1-clone" key="sidebar-title">
                    {" "}
                    {this.props.title}{" "}
                </h2>{" "}
                <div key="sidebar" className="sidebar">
                    <div className="options">
                        {" "}
                        {Object.entries(this.state.options).map(
                            ([id, optionGroup]) => {
                                return (
                                    <OptionCheckBoxGroup
                                        key={optionGroup.header}
                                        title={optionGroup.header}>
                                        {" "}
                                        {optionGroup.options.map(item => {
                                            if (item.label != "") {
                                                return (
                                                    <OptionCheckBox
                                                        key={`${item.value}-${
                                                            item.label
                                                        }`}
                                                        container={
                                                            optionGroup.header
                                                        }
                                                        name={item.label}
                                                        checked={
                                                            this.state[
                                                                optionGroup
                                                                    .header
                                                            ] === item.value
                                                        }
                                                        value={item.value}
                                                        onClick={() => {
                                                            this.setState(
                                                                {
                                                                    [optionGroup.header]:
                                                                        this
                                                                            .state[
                                                                                optionGroup
                                                                                    .header
                                                                            ] ===
                                                                        item.value
                                                                            ? undefined
                                                                            : item.value
                                                                },
                                                                this.props.returnSelectedOption(
                                                                    optionGroup.key,
                                                                    this.state[
                                                                        optionGroup
                                                                            .header
                                                                    ] ===
                                                                        item.value
                                                                        ? undefined
                                                                        : item.value
                                                                )
                                                            );
                                                        }}
                                                    />
                                                );
                                            }
                                        })}{" "}
                                        {optionGroup.select && (
                                            <Select.Async
                                                key={`search-${
                                                    optionGroup.header
                                                }`}
                                                name=""
                                                multi
                                                loadOptions={
                                                    this.fetchManufacturers
                                                }
                                                value={
                                                    this.state
                                                        .selectedManufacturers
                                                }
                                                onChange={this.handleSelect}
                                                placeholder="Search for Manufacturers"
                                            />
                                        )}{" "}
                                        {optionGroup.range && (
                                            <NewRange
                                                min={optionGroup.min}
                                                max={optionGroup.max}
                                                allowCross={false}
                                                value={
                                                    this.state.options[id].range
                                                }
                                                onChange={newRange => {
                                                    let newOptionsState = this
                                                        .state.options;

                                                    newOptionsState[
                                                        id
                                                    ].range = newRange;
                                                    this.setState({
                                                        options: newOptionsState
                                                    });
                                                }}
                                                onAfterChange={() => {
                                                    // this.props.returnSelectedOption("price_decimal", `[${this.state.options[id].range[0]}.00 TO ${this.state.options[id].range[1]}.00]`);
                                                    // Temp Just display "Max text"
                                                    this.props.returnSelectedOption(
                                                        "price_decimal",
                                                        `[${
                                                            this.state.options[
                                                                id
                                                            ].range[0]
                                                        }.00 TO Max`
                                                    );
                                                }}
                                                marks={{
                                                    [optionGroup.min]: `$${
                                                        optionGroup.min
                                                    }`,
                                                    // [optionGroup.max]: `$${optionGroup.max}`
                                                    // Temp Just display "Max text"
                                                    [optionGroup.max]: `Max`
                                                }}
                                                handle={handle}
                                            />
                                        )}{" "}
                                    </OptionCheckBoxGroup>
                                );
                            }
                        )}{" "}
                        {this.props.resetSelectedOptions && (
                            <OptionCheckBoxGroup
                                key="clear-option"
                                title="Clear / Apply Filters">
                                <Button
                                    label="Clear"
                                    onClick={() => {
                                        this.props.resetSelectedOptions();
                                    }}
                                />{" "}
                            </OptionCheckBoxGroup>
                        )}{" "}
                    </div>{" "}
                </div>{" "}
                <div
                    key="additionl-side-content"
                    className="additionl-side-content">
                    {" "}
                    {this.props.children}{" "}
                </div>{" "}
            </div>
        );
    }

    fetchManufacturers(input) {
        if (!input) {
            return Promise.resolve({
                options: []
            });
        }

        return axios
            .get(
                `/api/manufacturers/brands/search?pageSize=10&filterGroups=[{"field":"page_title","value":"${encodeURIComponent(
                    input + "%"
                )}","condition":"like"}]`
            )
            .then(manufacturersResult => {
                let options = [];

                if (manufacturersResult.data.brands) {
                    options = manufacturersResult.data.brands.map(brand => {
                        return {
                            label: brand.page_title,
                            value: brand.option_id
                        };
                    });
                }

                return {
                    options: options
                };
            })
            .catch(err => {
                console.error(err);
            });
    }

    handleSelect(selectedOption) {
        this.setState(
            {
                selectedManufacturers: selectedOption
            },
            this.props.returnSelectedOption(
                "manufacturer_facet",
                selectedOption.map(result => result.value).join(",")
            )
        );
    }
}

Sidebar.propTypes = {
    title: PropTypes.string,
    options: PropTypes.object,
    returnSelectedOption: PropTypes.func,
    resetSelectedOptions: PropTypes.func,
    children: PropTypes.any
};
